import { render } from "./LanguageSwitch.vue?vue&type=template&id=9947ae24&ts=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitch.vue?vue&type=script&lang=ts"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=9947ae24&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__